import React from 'react';

const AboutPage = ({ ...props }) => {
  return (
    <div>
      <h1>About Page</h1>
    </div>
  );
};

export default AboutPage;
